import React, { FC, useRef } from "react";
import { useTranslation } from "react-i18next";

import { capitalizeFirstLetter } from "../../../../utils";
import { LingerieQuestionConfig } from "../../../../constants/lingerieFlow";
import LingerieOptionButton from "./LingerieOptionButton";
import LingerieContinueButton from "./LingerieContinueButton";

interface StepLingerieQuestionProps {
  config: LingerieQuestionConfig;
  value: string | null;
  onChange: (value: string) => void;
  nextStep: () => void;
  subtitlesStyles: React.CSSProperties;
}

const StepLingerieQuestion: FC<StepLingerieQuestionProps> = ({
  config,
  value,
  onChange,
  nextStep,
  subtitlesStyles,
}) => {
  const { t } = useTranslation("components/lingerie-question");
  const continueButtonRef = useRef<HTMLButtonElement>(null);

  const descriptionKey = `${config.translationPrefix}.description`;
  const hasSpecificDescription = t(descriptionKey) !== descriptionKey;
  const description = hasSpecificDescription ? t(descriptionKey) : t("description");

  return (
    <div>
      <span
        className="description"
        style={{
          marginTop: "10px",
          ...subtitlesStyles,
          justifyContent:
            subtitlesStyles.textAlign as React.CSSProperties["justifyContent"],
          textAlign:
            subtitlesStyles.textAlign as React.CSSProperties["textAlign"],
          textTransform: (subtitlesStyles.textTransform === "capitalize"
            ? "none"
            : subtitlesStyles.textTransform) as React.CSSProperties["textTransform"],
        }}
      >
        {subtitlesStyles.textTransform === "capitalize"
          ? capitalizeFirstLetter(description)
          : description}
      </span>
      <div
        tabIndex={0}
        className="gender-buttons"
        style={{
          marginBottom: "30px",
          display: "flex",
          flexDirection: "column",
          gap: "20px",
        }}
      >
        {config.options.map(({ id, translationKey }) => (
          <LingerieOptionButton
            key={id}
            id={id}
            label={t(`${config.translationPrefix}.sizes.${translationKey}`)}
            selected={value === id}
            onSelect={() => {
              onChange(id);
              requestAnimationFrame(() => {
                continueButtonRef.current?.focus();
              });
            }}
          />
        ))}
      </div>
      <LingerieContinueButton
        ref={continueButtonRef}
        disabled={!value}
        onClick={nextStep}
      />
    </div>
  );
};

export default StepLingerieQuestion;
